import React from 'react'
import { csvHeaders, exampleCSVdata } from '../../assets/csv/exampleCSVdata';
import { CSVLink } from 'react-csv';
import { Box, Typography } from '@mui/material';
import IconDownload from "../../assets/images/icons/icon-download.png"

type Props = {}

function DownloadExampleCSV({ }: Props) {

    const csvValue = exampleCSVdata;

    const csvData = csvValue.map((row: any) => ({
        CustomerId: row.address,
        amount: Number(row.balance).toLocaleString('en-US', { minimumFractionDigits: 18, useGrouping: false }),
        ExternalId: row.externalCustomerId
    }));

    const csvReport = {
        filename: `example.csv`,
        headers: csvHeaders,
        data: csvData
    }

    return (
        <CSVLink style={{ textDecoration: 'none' }} {...csvReport} data={csvData}>
            <Typography
                fontWeight={400}
                color={'var(--gray)'}
                sx={{
                    zIndex: 100,
                    fontSize: { xs: '12px', sm: '14px' },
                    cursor: 'pointer',
                    transition: 'transform 0.3s ease', // Smooth scaling transition
                    '&:hover': {
                        transform: 'scale(1.2)', // Scale on hover
                    },
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                (Download example .CSV file here)
                <Box sx={{ marginLeft: '10px' }}>
                    <img src={IconDownload} alt="Download CSV" width={34} height={28} />
                </Box>
            </Typography>
        </CSVLink>
    )
}

export default DownloadExampleCSV